<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card header-class="redmfu">
            <div slot="header">
              <strong v-if="thai_student==1">แบบสอบถาม</strong>
              <strong v-else>Questionnaire</strong>
              <div style="float:right;">
                <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                  {{ this.$store.state.timeExp }}
                </b-badge>
              </div>
            </div>
            <b-form-group label-cols-sm="1" label label-align-sm="right" label-for="nested-street">
              <b-form-group :label="lbl_q1" :label-cols="5">
                <b-row class="align-items-center">
                  <b-col cols="6">
                    <b-button
                      block
                      pressed
                      :variant="current_bt1"
                      @click="onClickGeneral"
                    >{{ current_question1_txt }}
                    </b-button>
                  </b-col>
                  <b-col cols="6">
                    <b-button
                      block
                      variant="warning"
                      @click="onClickEditGeneral"
                      v-if="current_question1==1 && current_graduatestatus==0"
                    >{{ current_question1_edit }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-form-group>
<!--              <b-form-group :label="lbl_q2" :label-cols="5">-->
<!--                <b-row class="align-items-center">-->
<!--                  <b-col cols="6">-->
<!--                                        current_question7== {{current_question7}}<br>-->
<!--                                        current_graduatestatus =={{current_graduatestatus}}-->
<!--                    <b-button-->
<!--                      block-->
<!--                      pressed-->
<!--                      :variant="current_bt7"-->
<!--                      @click="onClickPart7"-->
<!--                    >{{ current_question7_txt }}-->
<!--                    </b-button>-->
<!--                  </b-col>-->
<!--                  <b-col cols="6">-->
<!--                    <b-button-->
<!--                      block-->
<!--                      variant="warning"-->
<!--                      @click="onClickEditPart7"-->
<!--                      v-if="current_question7==1 && current_graduatestatus==0"-->
<!--                    >{{ current_question7_edit }}-->
<!--                    </b-button>-->
<!--                  </b-col>-->
<!--                </b-row>-->
<!--              </b-form-group>-->

<!--              current_question7== {{current_question7}}<br>-->
<!--              current_graduatestatus =={{current_graduatestatus}}-->
<!--              <br>-->
              <b-form-group :label="lbl_q2" :label-cols="5">
                <b-row class="align-items-center">
<!--                  <b-col cols="6">-->
<!--                    <b-button-->
<!--                      block-->
<!--                      pressed-->
<!--                      :variant="current_bt7"-->
<!--                      @click="onClickPart7"-->
<!--                    >{{ current_question7_txt }}-->
<!--                    </b-button>-->
<!--                  </b-col>-->
<!--                  10==={{current_question7}}-->
<!--                  part10=={{ current_question7 }}-->
                  <b-col cols="6" v-if="current_question7!=15 ">
                    <b-button
                      block
                      pressed
                      variant="danger"
                      @click="onClickEditPart7"
                    >{{incomplete_txt}}
                    </b-button>
                  </b-col>
                  <b-col cols="6" v-else>
                    <b-button
                      block
                      pressed
                      variant="success"
                      @click="onClickPart7"
                    >{{complete_txt}}
                    </b-button>
                  </b-col>


<!--                  <b-col cols="6">-->
<!--                    <b-button-->
<!--                      block-->
<!--                      variant="warning"-->
<!--                      @click="onClickEditPart7"-->
<!--                      v-if="current_question7==1 "-->
<!--                    >{{ current_question7_edit }}-->
<!--                    </b-button>-->
<!--                  </b-col>-->
                </b-row>
              </b-form-group>



              <b-form-group :label="lbl_q3" :label-cols="5">
                <b-row class="align-items-center" v-if="current_graduatestatus ==0">
                  <b-col cols="6">
                    <b-button
                      block
                      pressed
                      :variant="current_bt5"
                      @click="onClickRegis"
                    >{{ current_graduatestatus_txt }}
                    </b-button>
                  </b-col>
                  <b-col cols="6" v-if="current_graduatestatus !=0">
                    <b-button
                      block
                      pressed
                      variant="warning"
                      @click="onClickRegisEdit"
                    >{{ current_graduateedit_txt }}
                    </b-button>
                  </b-col>
                </b-row>

                <b-row
                  v-if="current_graduatestatus ==10 || current_graduatestatus ==21 || current_graduatestatus ==22|| current_graduatestatus ==23 || current_graduatestatus ==30 || current_graduatestatus ==40">
                  <b-col cols="6">
                    <b-button
                      block
                      pressed
                      variant="success"
                      @click="onClickRegisdetail"
                    >{{ lblcbo_regis10 }}
                    </b-button>
                  </b-col>
                  <b-col cols="6">
                    <b-button
                      block
                      pressed
                      variant="info"
                      @click="onClickPrintRegis"
                    >{{ lblcbo_downloadregis }}
                    </b-button>

                  </b-col>
                </b-row>
                <b-row class="align-items-center"
                       v-if="(current_graduatestatus==50 || current_graduatestatus==60   )">

                  <b-col cols="6"
                         v-if="(current_graduatestatus==50 || current_graduatestatus==60  )">
                    <b-button
                      block
                      pressed
                      variant="success"
                      @click="onClickRegisdetail"
                      v-if="(current_graduatestatus==50 || current_graduatestatus==60   ) "
                    >{{ lblcbo_regisdetail }}
                    </b-button>
                  </b-col>
                  <b-col cols="6"
                         v-if="current_graduatestatus ==10  || current_graduatestatus ==20 || current_graduatestatus ==21 || current_graduatestatus ==22 || current_graduatestatus ==23 ||current_graduatestatus ==24 || current_graduatestatus ==30 || current_graduatestatus ==40  ">
                    <b-button
                      block
                      variant="primary"
                      @click="onClickPrintRegis"
                      v-if="current_graduatestatus ==10  || current_graduatestatus ==20 || current_graduatestatus ==21 || current_graduatestatus ==22 || current_graduatestatus ==23 ||current_graduatestatus ==24 || current_graduatestatus ==30 || current_graduatestatus ==40       "
                    >{{ current_question5_print }}
                    </b-button>
                  </b-col>
                </b-row>
                <br>
                <b-row v-if="current_graduatestatus !=0">
                  <b-col cols="6">
                  <b-button
                    block
                    variant="warning"
                    @click="onClickEditRegis"
                    v-if="thai_student==1"
                  > แก้ไขแจ้งความประสงค์เข้ารับพระราชทานปริญญาบัตร
                  </b-button>
                    <b-button
                      block
                      variant="warning"
                      @click="onClickEditRegis"
                      v-else
                    > Edit
                    </b-button>
                  </b-col>
                  <b-col cols="6"> </b-col>
                </b-row>
              </b-form-group>
              <!--              4. ยืนยันการติดต่อขอรับปริญญาบัตร-->
              <b-form-group :label="lbl_q4" :label-cols="5"
                            v-if="(current_graduatestatus==50 || current_graduatestatus==60)">
                <b-row v-if="(current_poststatus==''||current_poststatus==null)" class="align-items-center">
                  <b-col cols="6">
                    <b-button
                      block
                      pressed
                      variant="danger"
                      @click="onClickPost"
                    >
                      <div v-if="thai_student==1">ค้างบันทึกข้อมูล</div>
                      <div v-else>Incompleted</div>
                    </b-button>
                  </b-col>
                </b-row>
                <b-row v-if="(current_poststatus==11||current_poststatus==12)" class="align-items-center">
                  <b-col cols="6" v-if="current_poststatus==11">
                    <b-button
                      block
                      pressed
                      variant="primary"
                      @click="onClickPrintPost"
                    >
                      <div v-if="thai_student==1">พิมพ์ หนังสือยืนยันการขอรับปริญญาบัตร (ด้วยตนเอง)</div>
                      <div v-else>Print out form for Receipt of Degree Certificate</div>

                    </b-button>
                  </b-col>
                  <b-col cols="6" v-if="current_poststatus==12">
                    <b-button
                      block
                      pressed
                      variant="primary"
                      @click="onClickPrintPost"
                    >
                      <div v-if="thai_student==1">พิมพ์ หนังสือยืนยันการขอรับปริญญาบัตร (มอบฉันทะ)</div>
                      <div v-else>Print out form for Receipt of Degree Certificate (Authorize)</div>
                    </b-button>
                  </b-col>
                </b-row>
                <b-row class="align-items-center"
                       v-if="(current_poststatus==21||current_poststatus==22||current_poststatus==31)">
                  <b-col cols="6">
                    <b-button
                      block
                      pressed
                      variant="success"
                      @click="onClickPrintPost"
                      v-if="thai_student==1"
                    >{{ lblcbo_regisdetail }}
                    </b-button>
                    <b-button
                      block
                      pressed
                      variant="success"
                      @click="onClickPrintPost"
                      v-else
                    >Completed
                    </b-button>
                  </b-col>
                </b-row>
              </b-form-group>
              <!--              5. ชำระเงินค่าจัดส่งทางไปรษณีย์-->
              <b-form-group :label="lbl_q5" :label-cols="5"
                            v-if="(current_graduatestatus==50 || current_graduatestatus==60) && (current_poststatus ==21 ||  current_poststatus==22  ||  current_poststatus==31)">
                <b-row v-if=" paid_ready==0">
                  <b-col cols="6">
                    <form class="form-horizontal" role="form" :action="txt_url"
                          method="post"
                          v-if="(current_graduatestatus ==50  || current_graduatestatus ==60 )  && current_poststatus !=null   ">
                      <input type="hidden" name="channel" value="document">
                      <input type="hidden" name="std" :value="AAA">
                      <input type="hidden" name="urlback" :value="BBB">
                      <input type="hidden" name="lang" :value="CCC">
                      <input type="hidden" name="lockselect" value="1">
                      <button class="btn btn-danger" type="submit" v-if="thai_student==1">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ lbl_pay }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
                      <button class="btn btn-danger" type="submit" v-else>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ lbl_pay }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</button>
                      <!--                  <i class="fa fa-money"></i>-->
                    </form>
                  </b-col>
                </b-row>
                <b-row v-if="paid_ready==1">
                  <b-col cols="6">
                    <b-button
                      block
                      pressed
                      variant="success"

                    >
                      <div v-if="thai_student==1">
                        ชำระเงินแล้ว
                      </div>
                      <div v-else>
                        Paid already
                      </div>
                    </b-button>
                  </b-col>
                </b-row>
              </b-form-group>

            </b-form-group>


            <div slot="footer">
              <b-form-group label-cols-sm="1" label label-align-sm="right" label-for="nested-street">
                <b-row><font color=red>{{ word }} <br> {{ word2 }}</font>
                </b-row>
                <b-row><font color=red>{{ email }}</font>
                </b-row>
                <b-row><font color=red> {{ phone }}</font>
                </b-row>
                <b-row><font color=red>{{ person }}</font>
                </b-row>
              </b-form-group>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal
      v-if="thai_student==1"
      title="คุณกรอกข้อมูลไม่ครบถ้วน"
      class="modal-danger"
      v-model="dangerModal"
      @ok="dangerModal = false"
      ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
    <b-modal
      v-if="thai_student==0"
      title="You didn’t fill your information completely"
      class="modal-danger"
      v-model="dangerModal"
      @ok="dangerModal = false"
      ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";
export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      student: {},
      studentmain: {},
      std_id: "",
      AAA: "",
      BBB: "",
      CCC: "",
      sex: "",
      thai_student: "",
      word: "",
      word2: "",
      numEror: 0,
      current_erorrtxt: "",
      selected_regis: "",
      other_txt: "",
      selected_month: 0,
      dangerModal: false,
      txt_url:"",
      items: [],
      current_question1: "",
      current_question7: 0,
      q10: 0,
      current_question1_txt: "",
      current_question7_txt: "",
      current_question3_txt: "",
      current_question4_txt: "",
      current_question5_txt: "",
      current_graduatestatus: "",
      current_graduatestatus_txt: "",
      current_graduateedit_txt: "",
      lblcbo_regisdetail: "",
      lblcbo_regis10: "",
      lblcbo_downloadregis: "",


      current_link1: "",
      current_link2: "",
      current_link3: "",
      current_link4: "",
      current_link5: "",

      current_link1_edit: "",
      current_link2_edit: "",
      current_link3_edit: "",
      current_link4_edit: "",
      current_link5_edit: "",
      current_link6_edit: "",

      current_question1_edit: "",
      current_question7_edit: "",
      current_question3_edit: "",
      current_question4_edit: "",
      current_question5_edit: "",
      current_question6_edit: "",

      current_post_txt: "",
      current_post_print: "",

      current_link5_print: "",
      current_question5_print: "",

      current_link6_print: "",
      current_question6_print: "",
      current_bg: "",

      current_bt1: "",
      current_bt7: "",
      current_bt3: "",
      current_bt4: "",
      current_bt5: "",
      current_bt5_edit: "",
      lbl_pay: "",
      levelid: "",
      current_poststatus: "",
      lbl_q1: "",
      lbl_q2: "",
      lbl_q3: "",
      lbl_q4: "",
      lbl_q5: "",
      incomplete_txt:"",
      complete_txt:"",
      paid_ready: 0,
      poststatus: "",
      lbl_q6: "",
      email: "",
      phone: "",
      person: "",
      actionUpdate: 10,
    };
  },

  methods: {
    getStudentPost(student) {
      api
        .getStudentPostById(student)
        .then(res => {
          // console.log("res==", res);
          this.poststatus = res.data.data[0].POST_STATUS;
          this.paid_ready = res.data.data[0].PAIDAALREADY;
          // console.log("poststatus==", this.poststatus);
        })
        .catch(err => {
          // console.log("getStudentPost", err.toString());
          // this.$router.push("Index");
        });
    },
    onClickRegisdetail() {
      this.$router.push("/regisdetail");
    },
    onClickPrintPost() {
      if (this.current_poststatus == 11) {
        this.$router.push("/person");
      } else if (this.current_poststatus == 12) {
        this.$router.push("/authorized");
      } else if (
        this.current_poststatus == 21 ||
        this.current_poststatus == 22
      ) {
        this.$router.push("/postDetail");
      } else if (this.current_poststatus == 31) {
        this.$router.push("/postDetail"); //mail ออกมาแต่ รายงานดึงตัวเดียวกับ person
      }
    },

    onClickPost() {
      this.$router.push("/post");
    },
    onClickPrintRegis() {
      if (
        this.current_graduatestatus == 10 ||
        this.current_graduatestatus == 20 ||
        this.current_graduatestatus == 21 ||
        this.current_graduatestatus == 22 ||
        this.current_graduatestatus == 23 ||
        this.current_graduatestatus == 24 ||
        this.current_graduatestatus == 30 ||
        this.current_graduatestatus == 40
      ) {
        this.$router.push("/confirm"); //พริ้นใบรายงานตัว
      } else {
      }
    },
    onClickEditRegis() {
      this.$router.push("/regis");
    },
    onClickRegisEdit() {
      this.$router.push("/regis");
    },
    onClickRegis() {
      // console.log("this.current_graduatestatus==",this.current_graduatestatus);
      if ((this.current_graduatestatus > 0)) {
        this.$router.push("/regisdetail");
      } else if ((this.current_graduatestatus == 0) || (this.current_graduatestatus != null)) {
        this.$router.push("/regis");
      } else {
        this.$router.push("/regis");
      }
    },
    onClickEditQa() {
      this.$router.push("/qa");
    },
    onClickQa() {
      if (this.current_question4 != 1) {
        this.$router.push("/qa");
      } else {
        this.$router.push("/qadetail");
      }
    },
    onClickEdit5skills() {
      this.$router.push("/skills5");
    },
    onClick5skills() {
      if (this.current_question3 != 1) {
        this.$router.push("/skills5");
      } else {
        this.$router.push("/skills5detail");
      }
    },
    onClickPart7() {
      // console.log("current_question7==",this.current_question7)
      if ((this.current_question1 == 0) || (this.current_question1 == null) || (this.current_question1 == '')) {
        this.$router.push("/general");
      } else {
        if (this.current_question7 != 11) {
          this.$router.push("part10");
        } else {
          this.$router.push("/detailpart10");
        }
      }
    },
    onClickEditPart7() {
      this.$router.push("part10");
    },
    onClickEditGeneral() {
      this.$router.push("/general");
    },
    onClickGeneral() {
      if (this.current_question1 != 1) {
        this.$router.push("/general");
      } else {
        this.$router.push("/employment");
      }
    },
    getPostPay(studentid, thaistudent) {
      api
        .getStudentPostPay(studentid, thaistudent)
        .then(res => {
          // console.log("getPostPay==", res);
          this.AAA = res.data.data[0].STDREF;
        })
        .catch(err => {
          console.log("getCurrentStudent", err.toString());
          return 0;
        });
    },

    getCurrentPart10(studentid) {
      api
        .getAnsAllPart10(studentid)
        .then(res => {
          // console.log("res==",res,res.data.data.length)
          var count=0,rr=0;
          if (res.data.data.length==1) {
            if (res.data.data[0].QN_201 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_202 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_203 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_204 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_205 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_206 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_207 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_208 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_209 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_210 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_211 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_212 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_213 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_214 < 1) {
              rr++;
            } else {
              count++;
            }
            if (res.data.data[0].QN_215 < 1) {
              rr++;
            } else {
              count++;
            }
            this.current_question7 = count;
          }else{
            this.current_question7 =0;
          }
        //  console.log("e==",err,"c==",count)
        })
        .catch(err => {
          console.log("getCurrentPart10", err.toString());
          return 0;
        });
    },
    getCurrentStudent(studentid) {
      api
        .getQuestionaireStatus(studentid)
        .then(res => {
          //  console.log("current_question7==", this.current_question7);
          // console.log("length==", res.data.data.length );
          if (res.data.data.length == 1) {
            this.actionUpdate = 1
            this.current_question1 = res.data.data[0].QUESTIONNAIRE_1;
            // console.log("q10==", this.q10);
            // this.current_question7 = this.q10;
            // this.current_question7  =this.getCurrentPart10(this.std_id)
            // console.log( "528==",this.current_question7 );
            // console.log("current_question7==", this.current_question7);
            this.current_graduatestatus = res.data.data[0].GRADUATE_STATUS;
            this.current_poststatus = res.data.data[0].POST_STATUS;
            if ((this.current_graduatestatus == 50 || this.current_graduatestatus == 60) && (this.current_poststatus == 21 || this.current_poststatus == 22 || this.current_poststatus == 31)) {
              this.getPostPay(this.std_id, this.thai_student);
              var student = {};
              student.studentid = this.std_id;
              student.thaistudent = this.thai_student;
              this.getStudentPost(student);
            }
          } else {
            this.actionUpdate = 0;
            this.current_question1 = 0;
            // this.current_question7 = 0;
            this.current_graduatestatus = 0;
          }
          // console.log("current_question1==", this.current_question1);

          if (this.current_question1 == 1) {
            this.current_link1 = "#/employment";

            this.current_link1_edit = "#/part1";
            this.current_bt1 = "success";
            this.thai_student == 1
              ? (this.current_question1_edit = "แก้ไข")
              : (this.current_question1_edit = "Edit");

            this.thai_student == 1
              ? (this.current_question1_txt = "บันทึกข้อมูลสำเร็จ")
              : (this.current_question1_txt = "Completed");
          } else {
            this.current_link1 = "#/general";
            this.current_bt1 = "danger";
            this.thai_student == 1
              ? (this.current_question1_txt = "ค้างบันทึกข้อมูล")
              : (this.current_question1_txt = "Incompleted");
          }
          // console.log("xxxxx==",this.current_question7)
          if (this.current_question7 == 11) {
            // console.log("xxxxx")
            this.current_link2_edit = "part10";
            this.current_bt7 = "success";
            this.thai_student == 1
              ? (this.current_question7_edit = "แก้ไข")
              : (this.current_question7_edit = "Edit");

            this.thai_student == 1
              ? (this.current_question7_txt = "บันทึกข้อมูลสำเร็จ")
              : (this.current_question7_txt = "Completed");
          } else {
            this.current_link2 = "part10";
            this.current_bt7 = "danger";
            this.thai_student == 1
              ? (this.current_question7_txt = "ค้างบันทึกข้อมูล")
              : (this.current_question7_txt = "Incompleted");
          }
          if (this.current_graduatestatus > 0) {
            this.current_link5 = "#/regis";
            // this.current_link5_edit = "#/regis";

            this.thai_student == 1
              ? (this.current_graduateedit_txt =
                "แก้ไข")
              : (this.current_graduateedit_txt =
                "Edit");

            if (
              this.current_graduatestatus == 10 ||
              this.current_graduatestatus == 20 ||
              this.current_graduatestatus == 21 ||
              this.current_graduatestatus == 22 ||
              this.current_graduatestatus == 23 ||
              this.current_graduatestatus == 24 ||
              this.current_graduatestatus == 30 ||
              this.current_graduatestatus == 40
            ) {
              this.thai_student == 1
                ? (this.lblcbo_regis10 = "บันทึกข้อมูลสำเร็จ")
                : (this.lblcbo_regis10 = "Completed");
              this.thai_student == 1
                ? (this.lblcbo_downloadregis = "พิมพ์แบบรายงานตัวเข้ารับการฝึกซ้อมและรับพระราชทานปริญญาบัตร")
                : (this.lblcbo_downloadregis = "Print out the confirmation form to participate in the Rehearsal and Commencement Ceremony");

              this.current_link5_print = "#/confirm"; // ลิงค์ไปพร้ินรายงาน
              this.current_link5_edit = "#/regis";
              this.thai_student == 1
                ? (this.current_question5_print =
                  "พิมพ์แบบรายงานตัวเข้ารับการฝึกซ้อมและรับพระราชทานปริญญาบัตร")
                : (this.current_question5_print =
                  "Print out the confirmation form to participate in the Rehearsal and Commencement Ceremony");
            }
            // console.log(
            //   "this.current_graduatestatus ",
            //   this.current_graduatestatus
            // );
            if (
              this.current_graduatestatus == 50 ||
              this.current_graduatestatus == 60 ||
              this.current_graduatestatus == 70
            ) {
              // console.log("this.current_poststatus ", this.current_poststatus);

              this.thai_student == 1
                ? (this.lblcbo_regisdetail = "บันทึกข้อมูลสำเร็จ")
                : (this.lblcbo_regisdetail = "Completed");
              if (
                this.current_poststatus != "" &&
                this.current_poststatus != "None" &&
                this.current_poststatus != null
              ) {
                if (
                  this.current_poststatus == 21 ||
                  this.current_poststatus == 22
                ) {
                  // this.current_link6_print = "#/Regispost"; //แก้ลิงค์ด้วย
                  // this.thai_student == 1
                  //   ? (this.current_post_print = "พิมพ์ใบแจ้งยอดเพื่อชำระเงินพิมพ์ใบแจ้งยอดเพื่อชำระเงิน")
                  //   : (this.current_post_print = "Print out invoices");

                  this.thai_student == 1
                    ? (this.current_post_print = "ชำระเงิน")
                    : (this.current_post_print = "Pay");

                } else if (
                  this.current_poststatus == 11 ||
                  this.current_poststatus == 12
                ) {
                  if (this.thai_student == 1) {
                    this.current_post_print =
                      "พิมพ์ หนังสือยืนยันการขอรับปริญญาบัตร"
                    this.lbl_q6 = "4.ยืนยันการติดต่อขอรับปริญญาบัตร";
                  } else {
                    this.current_post_print =
                      "Print out form for Receipt of Degree Certificate ";
                    this.lbl_q6 = "4.The way to obtain Certificate";
                  }

                } else if (this.current_poststatus == 31) {
                  this.current_link5_print = "#/Person";
                  this.thai_student == 1
                    ? (this.current_post_print =
                      "พิมพ์  Mailing Service Application Form ")
                    : (this.current_post_print =
                      "Print out mailing Service Application Form");
                }
              } else {
                this.current_link5_print = "#/Post";

                this.thai_student == 1
                  ? (this.current_post_txt = "ค้างยืนยันการติดต่อขอรับปริญญา")
                  : (this.current_post_txt =
                    "Incompleted The way to obtain Certificate"); //The way to obtain Certificate
              }
            }
            this.current_bt5 = "success";
            this.thai_student == 1
              ? (this.current_question5_edit =
                "แก้ไขแจ้งความจำนงเข้ารับพระราชทานปริญญาบัตร")
              : (this.current_question5_edit = "Edit");
            this.thai_student == 1
              ? (this.current_graduatestatus_txt = "บันทึกข้อมูลสำเร็จ")
              : (this.current_graduatestatus_txt = "Completed");
          } else {
            this.current_link5 = "#/regis";
            this.current_bt5 = "danger";
            this.thai_student == 1
              ? (this.current_graduatestatus_txt = "ค้างบันทึกข้อมูล")
              : (this.current_graduatestatus_txt = "Incompleted");
          }
        })
        .catch(err => {
          console.log("getCurrentStudent", err.toString());
          this.$router.push("index");
        });
    },
    getLabelName(lid, thaistudent) {
      if (thaistudent == 1) {
        this.lbl_q1 = "1. แบบสอบถามภาวะการมีงานทำของบัณฑิต";
        this.lbl_q2 = "2. แบบประเมินตนเองของบัณฑิตต่อทักษะแห่งอนาคต ";
        this.lbl_q3 = "3. การแจ้งความประสงค์เข้ารับพระราชทานปริญญาบัตร";
        this.lbl_q4 = "4. ยืนยันการติดต่อขอรับปริญญาบัตร"
        this.lbl_q5 = "5. ชำระเงินค่าจัดส่งทางไปรษณีย์";
        this.lbl_pay = "ค้างชำระ";
        this.incomplete_txt="ค้างบันทึกข้อมูล";
        this.complete_txt="บันทึกข้อมูลสำเร็จ";
      } else {
        this.lbl_q1 = "1. Employment Survey";
        this.lbl_q2 = "2. Graduates’ Self-Assessment of Future Skills";
        this.lbl_q3 = "3. Confirmation to attend the commencement ceremony";
        this.lbl_q4 = "4. The way to obtain Certificate";
        this.lbl_q5 = "5. Payment";
        this.lbl_pay = "Payment";
        this.incomplete_txt="Incompleted";
        this.complete_txt="Completed";
      }

    }

  },
  created() {
    // console.log("store==", this.$store.state.user )
    if (this.$store.state.user.token == null || this.$store.state.user == null) {
      this.$router.push("/index");
    } else {
      if (this.$store.state.user != null) {
        this.txt_url="https://regstd.mfu.ac.th/debt/ipaymentp"; //จริง แก้ 3 ไฟล์ main-main70-postdetail
       // this.txt_url="https://regstdtest.mfu.ac.th/debt/ipaymentp";//ตัวเทส
        this.std_id = this.$store.state.user.studentid;
        this.std_id = this.$store.state.user.studentid;
        this.thai_student = this.$store.state.user.thaistudent;
        this.getCurrentPart10(this.std_id)
        this.actionUpdate = this.getCurrentStudent(this.std_id);
        this.getLabelName(this.levelid, this.thai_student);
        //this.BBB = "http://localhost:8080/#/Main";
        this.BBB = "https://ccr.mfu.ac.th/#/Main";
        if (this.thai_student == 1) {
          this.CCC = 'th';
        } else {
          this.CCC = 'en';
        }
        // this.getStudentPost(this.std_id, this.thai_student);
        if (this.thai_student == 1) {
          // this.word = "สำหรับผู้สำเร็จการศึกษาที่ยืนยันความประสงค์เข้ารับปริญญาบัตรแล้ว และต้องการยกเลิกการเข้ารับปริญญาบัตร ";
          // this.word2 = "กรุณาติดต่อ ส่วนพัฒนานักศึกษา ในวันและเวลาปฏิบัติงาน (จันทร์-ศุกร์ เวลา 08.00 - 16.00 น.)";
          // this.email = "E-mail: student.division@mfu.ac.th ";
          // this.phone = "โทรศัพท์:  053-916360,053-916181";
          // // this.phone="โทรศัพท์:  053-916-376-7";
          // this.person = "  ";
          this.word = "หากมีข้อสงสัยเกี่ยวกับการกรอกข้อมูล";
          this.word2 = "กรุณาติดต่อ ส่วนนโยบายและแผน ในวันและเวลาปฏิบัติงาน (จันทร์-ศุกร์ เวลา 08.00 - 16.00 น.)";
          this.email = "E-mail : admins@mfu.ac.th ";
          this.phone = "โทรศัพท์:  053 -916033";
          // this.phone="โทรศัพท์:  053-916-376-7";
          this.person = "  ";
        } else {
          // this.word="Any changes on the Confirmation of attending the MFU commencement ceremony, please contact the Global Relation Division (Ms.Yaowapa Phoemphul) at:"
          this.word = "Any changes on the Rehearsal and Commencement Ceremony, Please contact Global Relations Division at:";
          this.email = "E-mail: yaowapa.pho@mfu.ac.th";
          this.phone = "Telephone number :+66 53 91 6024";
          this.person = "(Working hours: Monday-Friday during 08.00-16.00 hrs.) ";
        }
        api.onSetHeader();
      } else {
        this.$router.push("/logout");
      }
    }
  }
}
;
</script>

